module.exports = __webpack_public_path__ + "static/media/unique.9985ee6b.png";